import { db } from './firebase';
import {
  collection,
  addDoc,
  onSnapshot,
  updateDoc,
  doc,
  serverTimestamp,
} from 'firebase/firestore';

const ACTIVE_TTL_MIN = 60;

function tsIn(ms) {
  return {
    seconds: Math.floor((Date.now() + ms) / 1000),
    nanoseconds: 0,
  };
}

export function streamIncidents(callback) {
  return onSnapshot(collection(db, 'incidents'), (snapshot) => {
    const now = Date.now();

    const data = snapshot.docs
      .map((doc) => ({ id: doc.id, ...doc.data() }))
      .filter((incident) => {
        if (incident.status === 'archived') return true;
        if (!incident.expiresAt?.seconds) return true; // keep if missing
        const expiresAtMs = incident.expiresAt.seconds * 1000;
        return expiresAtMs > now;
      });

    callback(data);
  });
}

export async function addIncident(incident) {
  const payload = {
    ...incident,
    status: 'active',
    createdAt: serverTimestamp(),
    expiresAt: tsIn(ACTIVE_TTL_MIN * 60 * 1000),
  };
  const ref = await addDoc(collection(db, 'incidents'), payload);
  console.log('🚨 addIncident: wrote ID', ref.id, payload);
  return ref.id;
}

export async function archiveIncident(incident, extra = {}) {
  const ref = doc(db, 'incidents', incident.id);
  
  const positiveSummaries = [
    "Victim is safe and in recovery.",
    "First responders arrived on time and prevented escalation.",
    "No major injuries reported.",
    "Community members assisted until help arrived.",
    "Situation resolved with no casualties."
  ];
  
  const summary = positiveSummaries[Math.floor(Math.random() * positiveSummaries.length)];

  await updateDoc(ref, {
    status: 'archived',
    archivedAt: serverTimestamp(),
    positiveSummary: summary,
    ...extra
  });
}

